import type { RouteRecordRaw } from 'vue-router'

import type { RedirectRouteRelative } from '@/utilities/routers'

import {
  routeNotificationsHome,
  routeNotificationsRoot,
} from '@/routers/routes/mainRoutes/routeSettings/routeAutomation/notificationRoutes.ts'

const routeAutomationHome: RouteRecordRaw = routeNotificationsHome

const routeAutomationRoot: RouteRecordRaw = {
  children: [routeAutomationHome, routeNotificationsRoot],
  path: 'automation',
}

const redirectAutomation: RedirectRouteRelative = {
  name: routeAutomationHome.name,
}

export { redirectAutomation, routeAutomationHome, routeAutomationRoot }
